import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";

const headerStyle = {
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  padding: "16px 20px",
  borderBottom: "2px solid #000080",
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#bb1ccc !important",
};

const cellStyle = {
  padding: "16px 20px",
  fontSize: "14px",
};

const DQResultsTable = ({
  rules = [],
  getQualityScoreColor = () => "#2c3e50",
  emptyMessage = "No rules found for the selected dataset.",
}) => (
  <TableContainer
    component={Paper}
    sx={{
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e0e0e0",
      borderRadius: "12px",
      marginTop: "30px",
      maxHeight: "500px",
      overflow: "auto",
    }}
  >
    <Table sx={{ minWidth: 650 }} stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell sx={headerStyle}>Column Name</TableCell>
          <TableCell sx={headerStyle}>Rule Description</TableCell>
          <TableCell sx={headerStyle}>Dimension</TableCell>
          <TableCell sx={headerStyle}>Keywords</TableCell>
          <TableCell sx={headerStyle}>Status</TableCell>
          <TableCell sx={headerStyle}>Score</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rules?.length ? (
          rules.map((rule, index) => (
            <TableRow
              key={rule.rule_name || `${rule.column_name}-${index}`}
              sx={{
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                "&:hover": {
                  backgroundColor: "#f0f8ff",
                  transition: "background-color 0.2s ease",
                },
              }}
            >
              <TableCell
                sx={{
                  ...cellStyle,
                  fontWeight: 600,
                  color: "#2c3e50",
                }}
              >
                {rule.check_type === "Asset Level Check"
                  ? "Asset Level Rule"
                  : rule.column_name}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  color: "#555",
                  maxWidth: "300px",
                  wordWrap: "break-word",
                }}
              >
                {rule.rule_description}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  color: "#555",
                  textTransform: "capitalize",
                }}
              >
                {rule.dimension_name
                  ? rule.dimension_name.charAt(0).toUpperCase() +
                    rule.dimension_name.slice(1)
                  : "N/A"}
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  color: "#555",
                  textTransform: "capitalize",
                }}
              >
                {rule.keywords || "N/A"}
              </TableCell>
              <TableCell sx={cellStyle}>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    px: 2,
                    py: 0.5,
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    backgroundColor:
                      rule.dq_result === "pass" ? "#e8f5e8" : "#ffeaea",
                    color: rule.dq_result === "pass" ? "#2e7d32" : "#d32f2f",
                  }}
                >
                  {rule.dq_result === "pass"
                    ? "Pass"
                    : rule.dq_result === "fail"
                    ? "Fail"
                    : rule.dq_result === "FAILURE"
                    ? "Not Run"
                    : "N/A"}
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  ...cellStyle,
                  fontWeight: 600,
                  color: getQualityScoreColor(rule.quality_score),
                }}
              >
                {rule.quality_score ?? "N/A"}%
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={6}
              align="center"
              sx={{
                padding: "40px 20px",
                fontSize: "16px",
                color: "#666",
                fontStyle: "italic",
              }}
            >
              {emptyMessage}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default DQResultsTable;


